'use client';

import Link from 'next/link';
import { createPathToTutorial } from '../services/routing';
import { TutorialPageId, getTutorialPages } from '../services/tutorialRepository';
import { useEffect, useState } from 'react';

const mobileThreshold = 768;

export default function TutorialNavigation({ activePageId }: { activePageId: TutorialPageId }) {
    const allPages = getTutorialPages();
    const [menuState, setMenuState] = useState({
        winWidth: 1024,
        isVisible: true,
    });

    useEffect(() => {
        function handleResize() {
            const newWidth = window.document.body.clientWidth;

            setMenuState((prev) => {
                let isVisible = prev.isVisible;

                if (newWidth > mobileThreshold && prev.winWidth <= mobileThreshold) {
                    isVisible = true;
                }

                if (newWidth <= mobileThreshold && prev.winWidth > mobileThreshold) {
                    isVisible = false;
                }

                return {
                    winWidth: newWidth,
                    isVisible,
                };
            });
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const width = window.document.body.clientWidth;

        setMenuState({ winWidth: width, isVisible: width > mobileThreshold });
    }, []);

    function handleMenu() {
        setMenuState((prev) => ({ ...prev, isVisible: !prev.isVisible }));
    }

    const isMenuButtonActive = menuState.winWidth < mobileThreshold;

    return (
        <>
            <aside className="menu">
                {isMenuButtonActive ? (
                    <a className="menu-label" href="#" onClick={handleMenu}>
                        <span className="icon">
                            <i className="fas fa-bars"></i>
                        </span>
                        List of Tutorial Pages
                        <span className="icon">
                            <i
                                className={`fas ${
                                    menuState.isVisible ? 'fa-arrow-up' : 'fa-arrow-down'
                                }`}
                            ></i>
                        </span>
                    </a>
                ) : (
                    <p className="menu-label">List of Tutorial Pages</p>
                )}
                {menuState.isVisible ? (
                    <ul className="menu-list">
                        {allPages.map((p) => (
                            <li key={p.id}>
                                <Link
                                    href={createPathToTutorial(p.numId)}
                                    className={p.id === activePageId ? 'is-active' : ''}
                                >
                                    {p.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                ) : null}
            </aside>
        </>
    );
}
